module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABYklEQVQ4jaWVzUrDQBSFT0ppMWBx5RuI+gK6lW7cdCH4uxBURASfy4XiVpEufIVg6+/WlUjV0kpFFPxc9A6mQ5KG9sJlmJwzX2aSexMBimUR2APqwAvwa+MlsGO6sjI+mQPuGIyuN78BZvMA54GOLWoAq0BoWgisA03T21lQd8xHMx8DpRRzCTiN7TTx+AIOzBRlwOJQt9PdNOCVGVaGwFyumb+epAfAu6QpSaGkLw2PUFJPUkvStC8GAJI6Bs0bXUmTkgJfKEhqS6pImsgJCw3WShILkiK703JOYM3GKFEF9u0hX+d4y2UrGeh3Tmod3pvpJANaBs7M18yqQ9d27VjRbgAV0yrAFnBr+hswAxwC1TSg6LeTK1oXPW/eMFgN+AY+fai/5SKwDVwAz8CPjed2vQAcGczFADRPZ/hZNQhJ0FGAWdClUYEO+uFBn8YBCljk/zsK8DouUMAC8ED/V7H5B+VLK60hZePzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search.png
// module id = p1AH
// module chunks = 1